import { useState, useEffect } from 'react';
import { mixGetV1 } from 'services/mixin';

const CACHE_PREFIX = '13w_access_';

// 1. Danh sách Whitelist (Ưu tiên số 1)
const WHITELIST_PATHS = [
  '/academy?tab=checklist',
  '/login',
];

// 2. Danh sách Blacklist (Ưu tiên số 2)
const BLACKLIST_PATHS = [
  '/academy',
];

function getUserId(): string | null {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr).id : null;
}

function readCache(userId: string): boolean | null {
  const v = sessionStorage.getItem(CACHE_PREFIX + userId);
  return v === null ? null : v === '1';
}

// Hàm kiểm tra Whitelist & Blacklist dựa trên URL
const checkPathRules = (): { isWhitelisted: boolean; isBlacklisted: boolean } => {
  const fullPath = window.location.pathname + window.location.search;
  const pathName = window.location.pathname;

  // Khớp chính xác cả query string cho Whitelist
  const isWhitelisted = WHITELIST_PATHS.some((item) => fullPath === item);
  if (isWhitelisted) {
    return { isWhitelisted: true, isBlacklisted: false };
  }

  // Khớp tiền tố pathname cho Blacklist
  const isBlacklisted = BLACKLIST_PATHS.some((item) => pathName.startsWith(item));

  return { isWhitelisted: false, isBlacklisted };
};

const use13WAccess = (): { access: boolean | null; canAccess: boolean | null } => {
  const userId = getUserId();
  
  // ==========================================
  // 1. LUỒNG CŨ: GIỮ NGUYÊN HOÀN TOÀN
  // ==========================================
  const [access, setAccess] = useState<boolean | null>(() =>
    userId ? readCache(userId) : false
  );

  useEffect(() => {
    if (!userId) { 
      setAccess(false); 
      return; 
    }

    mixGetV1(`/api/v1/be/user/${userId}`)
      .then((res) => {
        const granted = !!(res?.status && res?.data && res.data.is_trader_13w === 1);
        sessionStorage.setItem(CACHE_PREFIX + userId, granted ? '1' : '0');
        setAccess(granted);
      })
      .catch(() => {
        setAccess((prev) => (prev === null ? false : prev));
      });
  }, [userId]);

  // ==========================================
  // 2. LUỒNG MỚI: XỬ LÝ canAccess
  // ==========================================
  const { isWhitelisted, isBlacklisted } = checkPathRules();

  let canAccess: boolean | null = access;

  if (isWhitelisted) {
    canAccess = true;      // Nằm trong Whitelist -> Luôn cho phép
  } else if (isBlacklisted) {
    canAccess = false;     // Nằm trong Blacklist -> Luôn chặn
  } else {
    canAccess = access;    // Không thuộc 2 danh sách -> Dùng kết quả của luồng cũ (API/Cache)
  }

  return { access, canAccess };
};

export default use13WAccess;